export const modal = {
  modifyTitle: "BUCHUNG BEARBEITEN",
  createTitle: "BUCHUNG ERSTELLEN",
  modifyAction: "Buchung bearbeiten",
  createAction: "Buchung erstellen",
  processing: "Buchung wird verarbeitet...",

  selectRoomType: "Zimmertyp auswählen",
  selectAccommodation: "Unterkunft auswählen",

  quantity: "Anzahl",
  arrival: "Anreise",
  departure: "Abreise",
  guestName: "Name des Gastes",
  email: "E-Mail",
  phone: "Telefon",
  guestsNumber: "Anzahl der Gäste",
  price: "Preis",
  cancel: "Abbrechen",

  noTemplateSummary: "Keine aktive Vorlage",
  noTemplateDetail: "Keine Vorlage verfügbar",

  limitReachedSummary: "Limit erreicht",
  limitPromotionDetail: "Sie können nicht mehr als 1 Angebot hinzufügen",
  limitTaxDetail: "Sie können nicht mehr als 1 Steuer hinzufügen",

  validations: {
    fillRequired: "Bitte füllen Sie alle Pflichtfelder aus.",
    phoneMin: "Die Telefonnummer muss mindestens 5 Ziffern haben.",
    selectDates: "Bitte wählen Sie An- und Abreisedatum aus.",
    guestsMin: "Die Anzahl der Gäste muss mindestens 1 betragen.",
    priceNegative: "Der Preis darf nicht negativ sein.",
  },
};

export default modal;
